const removeTrailingSlash = (url) => {
  if (url.length > 1) {
    return url.replace(/\/$/, '');
  }
  return url;
};

export default removeTrailingSlash;
